import { EventEmitter } from '@angular/core';
import { Option } from '@com-delta-omnichannel/mach';
import { SelectedRange } from '@com-delta-omnichannel/mach/lib/components/organisms/date-picker/models/date-picker.interfaces';
import { BookWidgetFieldUpdateTypes } from '../../../../constants/book-widget.constants';
import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';

export class MultiCityDesktopAdvanceExtended {
  bookWidgetFieldChange!: EventEmitter<BookWidgetFieldUpdateEvent>;

  onDateSelectionChange(
    event: SelectedRange,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes,
    index: number
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        selectedRange: event,
        flightIndex: index
      },
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onDropdownSelectionChange(
    event: Option,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: event.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  clearConnectionAirport(flightIndex: number) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        airportCode: '',
        airportCity: '',
        flightIndex
      },
      type: BookWidgetFieldUpdateTypes.connectionAirport
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }
}
